import React, { Component } from 'react';
import cartDefault from "../images/cartimages/ecom-cart.gif"
import LoaderFragrance from "../fragrance/images/LoadingFragrance.gif"
import close from "../images/icons/close1.png"
import deleteimg from "../images/lokal/delete.png"
import $ from "jquery";
import { getData, getCartItemsMultiple, pageHitAPICall } from '../services';
import brandIcon from "../images/icons/brandIcon.png";
import Lokal from "../images/lokal/Lokal-logo-B.png"
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons'
import LazyLoad from 'react-lazyload';
import { elasticLink, elasticHostURL } from "../config";
const elasticsearch = require("elasticsearch");
export default class cart extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedProduct: [],
            cartItemQuantity: '',
            itemNo: '',
            cartItem: [],
            storeData: [],
            taxData: [],
            loginShowPop: false,
            cartDetails: [],
            locationDetails: []
        };
        this.droploginClick = this.droploginClick.bind(this);
        this.deleteStoreFromCart = this.deleteStoreFromCart.bind(this);
        this.addToCartRestaurant = this.addToCartRestaurant.bind(this);
        this.addToCartCommonItem = this.addToCartCommonItem.bind(this);
        this.getCartItems = this.getCartItems.bind(this);
        this.fetchLocationDetails = this.fetchLocationDetails.bind(this);
    }
    componentDidMount() {
        this.getCartItems();
        $(".popOverlay").click(function () {
            $(".cartDiv").hide();
        });
        var sellerID = "";
        var moduleID = 4;
        var siteCategoryGroupId = "";
        if (window.sessionStorage.getItem('siteCategoryId')) {
            siteCategoryGroupId = window.sessionStorage.getItem('siteCategoryId');
        }
        else {
            sellerID = window.sessionStorage.getItem('sellerId')
        }
        pageHitAPICall(sellerID, moduleID, siteCategoryGroupId);
    }
    setLocationData(locationObject) {
        window.sessionStorage.setItem('cityTextGlobal', locationObject.city)
        localStorage.setItem('locationText', locationObject.locationName)
        localStorage.setItem('cityIdGlobal', locationObject.cityId)
        localStorage.setItem('cityId', locationObject.cityId);
        localStorage.setItem('cityText', locationObject.city)
        localStorage.setItem('locationId', locationObject.locationId)
        window.sessionStorage.setItem('stateId', locationObject.stateId)
        window.sessionStorage.setItem('stateName', locationObject.stateName)
        window.sessionStorage.setItem('pinCode', locationObject.pinCode)

        $("#txtGlobalLocation").attr('title', locationObject.locationName)
        $("#txtGlobalLocation").val(locationObject.locationName)
        $("#cartGlobalListDiv").hide()
        $("#cartGloballocationRemove").show()
        $("#txtGlobalLocation").prop("disabled", true);
        $("#cartGrandButtonDiv").show()
        $("#cartGrandButtonDiv").addClass('cartGrandButtonDivMobile')
        $(".cartContentCover").addClass('cartContentCoverMobile')
        $("#txtGlobalLocation").addClass('cart-locationiput')
    }
    removeLocationData() {
        window.sessionStorage.removeItem('cityTextGlobal')
        window.sessionStorage.removeItem('locationText')
        window.sessionStorage.removeItem('cityIdGlobal')
        localStorage.removeItem('locationId')
        window.sessionStorage.removeItem('stateId')
        window.sessionStorage.removeItem('stateName')
        window.sessionStorage.removeItem('pinCode')
        $("#cartGloballocationRemove").hide()
        $("#txtGlobalLocation").prop("disabled", false);
        $("#cartGrandButtonDiv").hide()
        $("#txtGlobalLocation").val('')
        $("#cartGrandButtonDiv").removeClass('cartGrandButtonDivMobile')
        $(".cartContentCover").removeClass('cartContentCoverMobile')
    }
    fetchLocationDetails() {
 
        document.getElementById("error").style.display = "none";
        if ($("#txtGlobalLocation").val() !== '' && $("#txtGlobalLocation").val().length > 2 && localStorage.getItem('isPincodeBased') === "false") {
            const postData = {
                "functionName": "lokal/globalLocations",
                "locationKeyword": $("#txtGlobalLocation").val(),
                "countryId":  window.sessionStorage.getItem('countryId')
            }
            getData(postData).then((data) => {
                if (data.data.success === "1") {
                    console.log("loooooooooooooooo",data)
                    $("#cartGlobalListDiv").show()
                    this.setState({
                        locationDetails: data.data.result
                    });
                }
                else {
                    $("#locationSearchHome").hide();
                    this.setState({
                        locationDetails: []
                    });
                }
                $(".locationClear").show();
            });
        }
        else if (localStorage.getItem('isPincodeBased') === "true" && $("#txtGlobalLocation").val() !== '' && $("#txtGlobalLocation").val().length > 1) {
            let myCategoryId = window.sessionStorage.getItem('siteCategoryId');
            var key = $("#txtGlobalLocation").val();
            let sellerId = window.sessionStorage.getItem('sellerId');
            let cityId = '';
            const postData = {
                functionName: "lokal/locationList",
                myCategoryId: myCategoryId,
                cityId: cityId,
                locationKeyword: key,
                storeId: '',
                sellerId: (sellerId === "null" ? '' : sellerId),
            }
            getData(postData).then((data) => {
                console.log("llllllllllll", data)
                if (data.data.success === "1" && data.data.result.locationDetails.length > 0) {
                    this.setState({
                        locationDetails: data.data.result.locationDetails,
                    });
                }
                else {

                    document.getElementById("error").style.display = "block"

                    setTimeout(function () {
                        document.getElementById("error").style.display = "none";
                    }, 2000);
                    // $("#error").show();
                    $("#txtGlobalLocation").val("")
                    this.setState({
                        locationDetails: [],
                    });
                }
                $(".locationClear").show();
            });

        }
        else {
            this.setState({
                locationDetails: []
            });
        }
    }
    droploginClick() {
        window.sessionStorage.setItem('loginFromCart', true);
        $(".loginPopUp").show();
        $(".loginForgotHide").show();
    };
    deleteStoreFromCart(storeId) {
        if (window.confirm("Do you want to delete the items in this store ?")) {
            var selectGroceryItemCart = JSON.parse(localStorage.getItem('selectedCartProduct')) || []
            var cookieNewGroceryItemValue = []
            var j = 0
            for (var i = 0; i < selectGroceryItemCart.length; i++) {
                if (storeId.toString() !== selectGroceryItemCart[i].storeId.toString()) {
                    cookieNewGroceryItemValue[j] =
                    {
                        storeId: selectGroceryItemCart[i].storeId.toString().trim(),
                        item_names: selectGroceryItemCart[i].item_names.toString().trim(),
                        item_ids: selectGroceryItemCart[i].item_ids.toString().trim(),
                        quantity: selectGroceryItemCart[i].quantity.toString().trim(),
                        item_prices: selectGroceryItemCart[i].item_prices.toString().trim(),
                        store_item_stock_ids: selectGroceryItemCart[i].store_item_stock_ids.toString().trim(),
                        pack_ids: selectGroceryItemCart[i].pack_ids.toString().trim(),
                        stock_quantity: selectGroceryItemCart[i].stock_quantity.toString().trim(),
                        item_image: selectGroceryItemCart[i].item_image.toString().trim(),
                        itemNo: selectGroceryItemCart[i].itemNo.toString().trim()
                    }
                    j = parseInt(j) + 1
                }
            }
            localStorage.setItem('selectedCartProduct', JSON.stringify(cookieNewGroceryItemValue))
            var selectCommonItemCart = JSON.parse(localStorage.getItem('selectCommonItemCart')) || []
            var cookieNewCommonItemValue = []
            j = 0
            for (var k = 0; k < selectCommonItemCart.length; k++) {
                if (storeId.toString() !== selectCommonItemCart[i].storeId.toString()) {
                    cookieNewCommonItemValue[j] =
                    {
                        storeId: selectCommonItemCart[k].storeId.toString().trim(),
                        itemId: selectCommonItemCart[k].itemId.toString().trim(),
                        itemName: selectCommonItemCart[k].itemName.toString().trim(),
                        quantity: selectCommonItemCart[k].quantity.toString().trim(),
                        itemTitle: selectCommonItemCart[k].itemTitle.toString().trim(),
                        brand: selectCommonItemCart[k].brand.toString().trim(),
                        sizeName: selectCommonItemCart[k].sizeName.toString().trim(),
                        sizeId: selectCommonItemCart[k].sizeId.toString().trim(),
                        cmItemSizeId: selectCommonItemCart[k].cmItemSizeId.toString().trim(),
                        itemMasterId: selectCommonItemCart[k].itemMasterId.toString().trim(),
                        netAmount: selectCommonItemCart[k].netAmount.toString().trim(),
                        mrp: selectCommonItemCart[k].mrp.toString().trim(),
                        itemImage: selectCommonItemCart[k].itemImage.toString().trim(),
                        itemNo: selectCommonItemCart[k].itemNo.toString().trim()
                    }
                    j = parseInt(j) + 1
                }
            }
            localStorage.setItem('selectCommonItemCart', JSON.stringify(cookieNewCommonItemValue))
            var selectRestaurantCart = JSON.parse(localStorage.getItem('selectRestaurantCart')) || []
            var cookieNewRestaurantValue = []
            var j = 0
            for (var l = 0; l < selectRestaurantCart.length; l++) {
                if (storeId.toString() !== selectRestaurantCart[l].storeId.toString()) {
                    cookieNewRestaurantValue[j] =
                    {
                        storeId: selectRestaurantCart[l].storeId.toString().trim(),
                        itemId: selectRestaurantCart[l].itemId.toString().trim(),
                        itemName: selectRestaurantCart[l].itemName.toString().trim(),
                        quantity: selectRestaurantCart[l].quantity.toString().trim(),
                        itemSize: selectRestaurantCart[l].itemSize.toString().trim(),
                        itemMrp: selectRestaurantCart[l].itemMrp.toString().trim(),
                        itemImage: selectRestaurantCart[l].itemImage.toString().trim(),
                        storeItemSizeId: selectRestaurantCart[l].storeItemSizeId.toString().trim(),
                        itemNo: selectRestaurantCart[l].itemNo.toString().trim(),
                        toppingsData: selectRestaurantCart[l].toppingsData.toString().trim()
                    }
                    j = parseInt(j) + 1
                }
            }
            localStorage.setItem('selectRestaurantCart', JSON.stringify(cookieNewRestaurantValue))
            if (cookieNewGroceryItemValue.length === 0 && cookieNewCommonItemValue.length === 0 && cookieNewRestaurantValue.length === 0) {
                window.location.reload();
            }
            else {
                this.getCartItems();
            }
            return true;
        }
        else {
            return false;
        }
    }
    getCartItems() {
        let cartSize = 0;
        var locationId = localStorage.getItem('locationId') === null ? '' : localStorage.getItem('locationId')
        var hasLocation = localStorage.getItem('hasLocation') === '1' ? '1' : '0'
        var grocery = []
        if (JSON.parse(localStorage.getItem('selectedCartProduct')) !== null) {
            if (JSON.parse(localStorage.getItem('selectedCartProduct')).length > 0) {
                grocery[0] = {
                    cartCategory: "grocery",
                    locationId: locationId,
                    selectedProduct: JSON.parse(localStorage.getItem('selectedCartProduct'))
                }
            }
        }
        var commonItem = []
        if (JSON.parse(localStorage.getItem('selectCommonItemCart')) !== null) {
            if (JSON.parse(localStorage.getItem('selectCommonItemCart')).length > 0) {
                commonItem[0] = {
                    cartCategory: "commonItem",
                    locationId: locationId,
                    cityId: '',
                    selectCommonItemCart: JSON.parse(localStorage.getItem('selectCommonItemCart'))
                }
            }
        }
        var restaurant = []
        if (JSON.parse(localStorage.getItem('selectRestaurantCart')) !== null) {
            if (JSON.parse(localStorage.getItem('selectRestaurantCart')).length > 0) {
                restaurant[0] = {
                    cartCategory: "restaurant",
                    locationId: locationId,
                    selectRestaurantCart: JSON.parse(localStorage.getItem('selectRestaurantCart'))
                }
            }
        }
        var postData = {
            "functionName": "cartItem",
            "commonItem": commonItem,
            "restaurant": restaurant,
            "grocery": grocery,
            "paymentId": "",
            "hasLocation": hasLocation,
            "timeZone": new Date().getTimezoneOffset().toString(),
            "enableOnHold": "0"
        }
        getCartItemsMultiple(postData).then((data) => {
            console.log("kkkkk", data)
            if (data.data.success === '1') {
                this.setState({
                    cartDetails: data.data.result
                });
                if (JSON.parse(localStorage.getItem('selectedCartProduct')) !== null) {
                    cartSize = JSON.parse(localStorage.getItem('selectedCartProduct')).length
                }
                if (JSON.parse(localStorage.getItem('selectRestaurantCart')) !== null) {
                    cartSize = cartSize + JSON.parse(localStorage.getItem('selectRestaurantCart')).length
                }
                if (JSON.parse(localStorage.getItem('selectCommonItemCart')) !== null) {
                    cartSize = cartSize + JSON.parse(localStorage.getItem('selectCommonItemCart')).length
                }
                $("#cartCount").text(cartSize)
            }
        })
    }

    addToCart(itemNo, storeId, sisId, itemId, itemPrice, packId, type, stockQuantity, itemName, quantity, image, cartItemNo) {
 
        let isDelete = false;
        let themeId = localStorage.getItem('themeId')
        if (type === "inc") {
            var prnum = $('#itemQty' + itemNo).val();
            if (parseInt(prnum) >= parseInt(stockQuantity)) {
                $("#qtyErrorCart" + itemNo).show();
                $("#qtyErrorCart" + itemNo).text("Only " + stockQuantity + " qty available")
                $('#itemQty' + itemNo).val(stockQuantity)
                $("#itemCount" + cartItemNo).text(stockQuantity)
                $("#txtQty" + cartItemNo).val(stockQuantity)
                //////for save more
                $("#txtQtyMain" + cartItemNo).val(stockQuantity)
                $("#txtQtySwap" + cartItemNo).val(stockQuantity)
                $("#itemCountMain" + cartItemNo).text(stockQuantity)
                $("#itemCountSwap" + cartItemNo).text(stockQuantity)
                // for theme
                if (themeId === '36') {
                    $(".addToCartTheme" + cartItemNo).text(stockQuantity)
                }

            }
            else {
                prnum++;
                $("#qtyErrorCart" + itemNo).hide();
                $("#qtyErrorCart" + itemNo).text("")
                $('#itemQty' + itemNo).val(prnum);
                $("#txtQty" + cartItemNo).val(prnum)
                $("#itemCount" + cartItemNo).text(prnum)
                //for save more
                $("#txtQtyMain" + cartItemNo).val(prnum)
                $("#txtQtySwap" + cartItemNo).val(prnum)
                $("#itemCountMain" + cartItemNo).text(prnum)
                $("#itemCountSwap" + cartItemNo).text(prnum)
                // for theme
                if (themeId === '36') {
                    $(".addToCartTheme" + cartItemNo).text(prnum)
                }

            }
        }
        else if (type === "dec") {
            $("#qtyErrorCart" + itemNo).hide();
            $("#qtyErrorCart" + itemNo).text("")
            var prnum = $('#itemQty' + itemNo).val();
            prnum--;
            if (prnum == 0) {
                isDelete = true;
                $("#itemCount" + cartItemNo).text("")
                $("#itemAddedColour" + cartItemNo).hide()
                $('#addToCart' + cartItemNo).removeClass("cart_clk");
                $('#itemQty' + itemNo).val(prnum);
                $("#addToCart" + cartItemNo).text("ADD TO CART")
                ////for save more
                $("#itemCountMain" + cartItemNo).text("")
                $("#itemCountSwap" + cartItemNo).text("")
                $("#itemAddedColourMain" + cartItemNo).hide()
                $("#itemAddedColourSwap" + cartItemNo).hide()
                // for theme
                if (themeId === '36') {
                    $('.addcartbtnTheme' + cartItemNo).removeClass("addcartActive");
                    $(".addToCartTheme" + cartItemNo).text('+')
                }
            }
            else {
                $("#itemCount" + cartItemNo).text(prnum)
                $("#txtQty" + cartItemNo).val(prnum)
                ////for save more
                $("#itemCountMain" + cartItemNo).text(prnum)
                $("#itemCountSwap" + cartItemNo).text(prnum)
                $("#txtQtyMain" + cartItemNo).val(prnum)
                $("#txtQtySwap" + cartItemNo).val(prnum)
                // for theme
                if (themeId === '36') {
                    $(".addToCartTheme" + cartItemNo).text(prnum)
                }
            }
            $('#itemQty' + itemNo).val(prnum);
        }
        else if (type === "remove") {
            $("#qtyErrorCart" + itemNo).hide();
            $("#qtyErrorCart" + itemNo).text("")
            $("#productItemList" + cartItemNo).remove()
            $("#itemCount" + cartItemNo).text("")
            $("#itemAddedColour" + cartItemNo).hide()
            $('#addToCart' + cartItemNo).removeClass("cart_clk");
            $("#txtQty" + cartItemNo).val(0)
            $('#itemQty' + itemNo).val(0);
            $("#addToCart" + cartItemNo).text("ADD TO CART")
            ////for save more
            $("#itemCountMain" + cartItemNo).text("")
            $("#txtQtyMain" + cartItemNo).val(0)
            $("#itemCountSwap" + cartItemNo).text("")
            $("#itemAddedColourMain" + cartItemNo).hide()
            $("#itemAddedColourSwap" + cartItemNo).hide()
            $("#txtQtySwap" + cartItemNo).val(0)
            // for theme
            if (themeId === '36') {
                $('.addcartbtnTheme' + cartItemNo).removeClass("addcartActive");
                $(".addToCartTheme" + cartItemNo).text('+')
            }
        }
        this.updateCart(itemName, itemId, $('#itemQty' + itemNo).val(), itemPrice, sisId, packId, isDelete, stockQuantity, image, cartItemNo, storeId)
    }
    updateCart(item_names, item_ids, quantity, item_prices, store_item_stock_ids, pack_ids, isDelete, stock_quantity, itemImage, cartItemNo, storeId) {

        var selectedCartProduct = JSON.parse(localStorage.getItem('selectedCartProduct')) || []
        if (localStorage.getItem('selectedCartProduct') === null) {
            if (isDelete === false || quantity > 0) {
                var selectedProduct = {
                    storeId: storeId,
                    item_names: item_names,
                    item_ids: item_ids,
                    quantity: quantity,
                    item_prices: item_prices,
                    store_item_stock_ids: store_item_stock_ids,
                    pack_ids: pack_ids,
                    stock_quantity: stock_quantity,
                    item_image: itemImage,
                    itemNo: cartItemNo
                }
                selectedCartProduct.push(selectedProduct)
                localStorage.setItem('selectedCartProduct', JSON.stringify(selectedCartProduct))
            }
        }
        else {
            var selectedCartProduct = JSON.parse(localStorage.getItem('selectedCartProduct')) || []
            var cookieNewValue = [];
            var cookieArray = selectedCartProduct;
            var cookieUpdated = false
            var cookieNewValueCount = 0;
            for (var i = 0; i < cookieArray.length; i++) {
                if (cookieArray[i] !== null && cookieArray[i] !== 'null' && cookieArray[i] !== "") {
                    var cookieStoreId = cookieArray[i].storeId
                    var cookieItemId = cookieArray[i].item_ids
                    if (item_ids === cookieItemId && storeId === cookieStoreId) {
                        if (isDelete === false && quantity > 0) {
                            cookieNewValue[cookieNewValueCount] =
                            {
                                storeId: storeId,
                                item_names: item_names,
                                item_ids: item_ids,
                                quantity: quantity,
                                item_prices: item_prices,
                                store_item_stock_ids: store_item_stock_ids,
                                pack_ids: pack_ids,
                                stock_quantity: stock_quantity,
                                item_image: itemImage,
                                itemNo: cartItemNo
                            }
                            cookieNewValueCount++;
                        }
                        cookieUpdated = true
                    }
                    else {
                        cookieNewValue[cookieNewValueCount] = cookieArray[i];
                        cookieNewValueCount++;
                    }
                }
            }
            if (cookieUpdated === false) {
                if (quantity > 0) {
                    cookieNewValue[cookieNewValueCount] = {
                        storeId: storeId,
                        item_names: item_names,
                        item_ids: item_ids,
                        quantity: quantity,
                        item_prices: item_prices,
                        store_item_stock_ids: store_item_stock_ids,
                        pack_ids: pack_ids,
                        stock_quantity: stock_quantity,
                        item_image: itemImage,
                        itemNo: cartItemNo
                    }
                    cookieUpdated = true
                }
            }
            localStorage.setItem('selectedCartProduct', JSON.stringify(cookieNewValue))
        }
        if (cookieNewValue.length === 0) {
            window.location.reload();
        }
        this.getCartItems();
    }
    isNumber = (e, itemNo, stock_quantity, itemName, itemId, itemPrice, sisId, packId, quantity, image, cartItemNo, storeId) => {
        let isDelete = false;
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            var prnum = $('#itemQty' + itemNo).val();
            if (parseInt(prnum) >= parseInt(stock_quantity)) {
                prnum = stock_quantity;
                $("#qtyErrorCart" + itemNo).show();
                $("#qtyErrorCart" + itemNo).text("Only " + stock_quantity + " qty available")
                $('#itemQty' + itemNo).val(stock_quantity)
                $("#itemCount" + cartItemNo).text(stock_quantity)
                $("#txtQty" + cartItemNo).val(stock_quantity)
                ////for save more
                $("#itemCountMain" + cartItemNo).text(stock_quantity)
                $("#itemCountSwap" + cartItemNo).text(stock_quantity)
                $("#txtQtyMain" + cartItemNo).val(stock_quantity)
                $("#txtQtySwap" + cartItemNo).val(stock_quantity)
            }
            else if (prnum == 0) {
                isDelete = true;
                $("#itemCount" + cartItemNo).text("")
                $("#itemAddedColour" + cartItemNo).hide()
                $('#addToCart' + cartItemNo).removeClass("cart_clk");
                $('#itemQty' + itemNo).val(prnum);
                $("#addToCart" + cartItemNo).text("ADD TO CART")
                $("#txtQty" + cartItemNo).val(prnum)
                ////for save more
                $("#itemCountMain" + cartItemNo).text("")
                $("#itemCountSwap" + cartItemNo).text("")
                $("#itemAddedColourMain" + cartItemNo).hide()
                $("#itemAddedColourSwap" + cartItemNo).hide()
                $("#txtQtyMain" + cartItemNo).text("")
                $("#txtQtySwap" + cartItemNo).text("")
            }
            else {
                $("#qtyErrorCart" + itemNo).hide();
                $("#qtyErrorCart" + itemNo).text("");
                $('#itemQty' + itemNo).val(prnum)
                $('#itemQty' + cartItemNo).val(prnum)
                $("#itemCount" + cartItemNo).text(prnum)
                $("#txtQty" + cartItemNo).val(prnum)
                ////for save more
                $("#itemCountMain" + cartItemNo).text(prnum)
                $("#itemCountSwap" + cartItemNo).text(prnum)
                $("#txtQtyMain" + cartItemNo).val(prnum)
                $("#txtQtySwap" + cartItemNo).val(prnum)
            }
        }
        else {
            var prnum = e.target.value.replace(/[^0-9\.]/g, '');
            $('#itemQty' + itemNo).val(prnum)
        }
        this.updateCart(itemName, itemId, $('#itemQty' + itemNo).val(), itemPrice, sisId, packId, isDelete, stock_quantity, image, cartItemNo, storeId)
    }
    addToCartRestaurant(type, itemId, storeId, itemName, itemMrp, itemImage, itemSize, storeItemSizeId, toppingsData) {
        let isDelete = false;
        let itemNo = itemId + '-' + storeItemSizeId + '-' + toppingsData.toString().replace(',', '-')
        if (type === "addToCart") {
            $('#addToCart' + itemNo).addClass("cart_clk");
            if ($('.cartInput' + itemNo).val() == 0) {
                $('.cartInput' + itemNo).val(1);
            }
        }
        else if (type === "inc") {
            var addItem = $('.cartInput' + itemNo).val()
            addItem++;
            if (addItem > 0) {
                $('.cartInput' + itemNo).val(addItem);
            }
            else if (addItem == 0) {
                $('.cartInput' + itemNo).val(1);
            }
        }
        else if (type === "dec") {
            var removeItem = $('.cartInput' + itemNo).val()
            removeItem--;
            if (removeItem == 0) {
                isDelete = true;
                $('#addToCart' + itemNo).removeClass("cart_clk");
                $("#addToCart" + itemNo).text("ADD TO CART")
            }
            $('.cartInput' + itemNo).val(removeItem);
        }
        else if (type === "txtChange") {
            var txtItem = $('.cartInput' + itemNo).val()
            if (txtItem == 0) {
                $('#addToCart' + itemNo).removeClass("cart_clk");
                $("#addToCart" + itemNo).text("ADD TO CART")
            }
            else {
                $('.cartInput' + itemNo).val(txtItem);
            }
        }
        else if (type === "remove") {
            $('#addToCart' + itemNo).removeClass("cart_clk");
            $("#txtQty" + itemNo).val(0)
            $('.cartInput' + itemNo).val(0)
            $("#addToCart" + itemNo).text("ADD TO CART")
        }
        this.updateCartRestaurant(storeId, itemId, itemName, $('.cartInput' + itemNo).val(), itemSize, itemMrp, itemImage, storeItemSizeId, isDelete, toppingsData)
        var itemCount = 0;
        var selectRestaurantCart = JSON.parse(localStorage.getItem('selectRestaurantCart')) || []
        for (var i = 0; i < selectRestaurantCart.length; i++) {
            var cookieItemId = selectRestaurantCart[i].itemId
            var cookieQuantity = selectRestaurantCart[i].quantity
            if (itemId === cookieItemId) {
                itemCount = parseInt(itemCount) + parseInt(cookieQuantity)
            }
        }
        if (itemCount === 0) {
            $("#itemCount" + itemId).text('0')
            $("#itemAddedColour" + itemId).hide()
        }
        else {
            $("#itemCount" + itemId).text(itemCount)
            $("#itemAddedColour" + itemId).show()
        }
    }
    updateCartRestaurant(storeId, itemId, itemName, quantity, itemSize, itemMrp, itemImage, storeItemSizeId, isDelete, toppingsData) {
        let itemNo = itemId + '-' + storeItemSizeId
        var selectRestaurantCart = JSON.parse(localStorage.getItem('selectRestaurantCart')) || []
        if (localStorage.getItem('selectRestaurantCart') === null) {
            if (isDelete === false || quantity > 0) {
                var selectedRestaurantProduct = {
                    storeId: storeId,
                    itemId: itemId,
                    itemName: itemName,
                    quantity: quantity,
                    itemSize: itemSize,
                    itemMrp: itemMrp,
                    itemImage: itemImage,
                    storeItemSizeId: storeItemSizeId,
                    itemNo: itemNo,
                    toppingsData: toppingsData
                }
                selectRestaurantCart.push(selectedRestaurantProduct)
                localStorage.setItem('selectRestaurantCart', JSON.stringify(selectRestaurantCart))
            }
        }
        else {
            var cookieNewRestaurantValue = [];
            var cookieRestaurantArray = selectRestaurantCart;
            var cookieRestaurantUpdated = false
            var cookieRestaurantNewValueCount = 0;
            for (var i = 0; i < cookieRestaurantArray.length; i++) {
                if (cookieRestaurantArray[i] !== null && cookieRestaurantArray[i] !== 'null' && cookieRestaurantArray[i] !== "") {
                    var cookieStoreId = cookieRestaurantArray[i].storeId
                    var cookieItemId = cookieRestaurantArray[i].itemId
                    var cookieSizeId = cookieRestaurantArray[i].storeItemSizeId
                    var toppingsDataFromCart = cookieRestaurantArray[i].toppingsData
                    var newTopping = false
                    if (null !== toppingsData && 'null' !== toppingsData && '' !== toppingsData) {
                        var toppingsDataFromCartSplit = toppingsData.split(',')
                        for (var t = 0; t < toppingsDataFromCartSplit.length; t++) {
                            if (toppingsDataFromCart.indexOf(toppingsDataFromCartSplit[t]) === -1) {
                                newTopping = true
                            }
                            else {
                                //   alert("else t")
                            }
                        }
                    }
                    else {
                        if (null !== toppingsDataFromCart && 'null' !== toppingsDataFromCart && '' !== toppingsDataFromCart) {
                            newTopping = true
                        }
                    }
                    if (itemId === cookieItemId && storeId === cookieStoreId && storeItemSizeId === cookieSizeId && newTopping === false) {
                        if (isDelete === false && quantity > 0) {
                            cookieNewRestaurantValue[cookieRestaurantNewValueCount] =
                            {
                                storeId: storeId,
                                itemId: itemId,
                                itemName: itemName,
                                quantity: quantity,
                                itemSize: itemSize,
                                itemMrp: itemMrp,
                                itemImage: itemImage,
                                storeItemSizeId: storeItemSizeId,
                                itemNo: itemNo,
                                toppingsData: toppingsData
                            }
                            cookieRestaurantNewValueCount++;
                        }
                        cookieRestaurantUpdated = true
                    }
                    else {
                        cookieNewRestaurantValue[cookieRestaurantNewValueCount] = cookieRestaurantArray[i];
                        cookieRestaurantNewValueCount++;
                    }
                }
            }
            if (cookieRestaurantUpdated === false) {
                if (quantity > 0) {
                    cookieNewRestaurantValue[cookieRestaurantNewValueCount] = {
                        storeId: storeId,
                        itemId: itemId,
                        itemName: itemName,
                        quantity: quantity,
                        itemSize: itemSize,
                        itemMrp: itemMrp,
                        itemImage: itemImage,
                        storeItemSizeId: storeItemSizeId,
                        itemNo: itemNo,
                        toppingsData: toppingsData
                    }
                    cookieRestaurantUpdated = true
                }
            }
            localStorage.setItem('selectRestaurantCart', JSON.stringify(cookieNewRestaurantValue))
        }
        $("#cartCount").text((JSON.parse(localStorage.getItem('selectRestaurantCart')).length))
        this.getCartItems();
    }
    isNumberRestaurant(e, itemId, storeId, itemName, itemMrp, itemImage, itemSize, storeItemSizeId, toppingsData) {
        let itemNo = itemId + '-' + storeItemSizeId + '-' + toppingsData.toString().replace(',', '-')
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            var prnum = $('.cartInput' + itemNo).val();
        }
        else {
            var prnum = e.target.value.replace(/[^0-9\.]/g, '');
            $('.cartInput' + itemNo).val(prnum)
        }
        this.addToCartRestaurant("txtChange", itemId, storeId, itemName, itemMrp, itemImage, itemSize, storeItemSizeId, toppingsData)
    }
    addToCartCommonItem(type, storeId, itemId, itemName, quantity, itemTitle, brand, sizeName, sizeId, cmItemSizeId, itemMasterId, netAmount, mrp, itemImage, maxBuyCount, availableQuantity) {
        let isDelete = false;
        let itemNo = itemId + '-' + cmItemSizeId
        if (type === "addToCart") {
            $('#addToCart' + itemNo).addClass("cart_clk");
            if ($('.cartInput' + itemNo).val() == 0) {
                $('.cartInput' + itemNo).val(1);
            }
        }
        else if (type === "inc") {
            var addItem = $('.cartInput' + itemNo).val()
            if (addItem > 0) {
                if (parseInt(addItem) >= parseInt(availableQuantity)) {
                    alert("Only " + availableQuantity + " qty available")
                }
                else if (parseInt(addItem) >= parseInt(maxBuyCount)) {
                    alert("You can buy maximum " + maxBuyCount)
                }
                else {
                    addItem++;
                    $('.cartInput' + itemNo).val(addItem);
                }
            }
            else if (addItem == 0) {
                $('.cartInput' + itemNo).val(1);
            }
        }
        else if (type === "dec") {
            var removeItem = $('.cartInput' + itemNo).val()
            removeItem--;
            if (removeItem == 0) {
                isDelete = true;
                $('#addToCart' + itemNo).removeClass("cart_clk");
            }
            $('.cartInput' + itemNo).val(removeItem);
        }
        else if (type === "txtChange") {
            var txtItem = $('.cartInput' + itemNo).val()
            if (txtItem == 0) {
                $('#addToCart' + itemNo).removeClass("cart_clk");
            }
            else {
                if (parseInt(txtItem) > parseInt(availableQuantity)) {
                    alert("Only " + availableQuantity + " qty available")
                }
                else if (parseInt(txtItem) > parseInt(maxBuyCount)) {
                    alert("You can buy maximum " + maxBuyCount)
                }
                else {
                    $('.cartInput' + itemNo).val(txtItem);
                }
            }
        }
        else if (type === "remove") {
            $('#addToCart' + itemNo).removeClass("cart_clk");
            $("#txtQty" + itemNo).val(0)
            $('.cartInput' + itemNo).val(0)
        }
        this.updateCartCommonItem(storeId, itemId, itemName, $('.cartInput' + itemNo).val(), itemTitle, brand, sizeName, sizeId, cmItemSizeId, itemMasterId, netAmount, mrp, itemImage, isDelete, maxBuyCount, availableQuantity)
    }
    updateCartCommonItem(storeId, itemId, itemName, quantity, itemTitle, brand, sizeName, sizeId, cmItemSizeId, itemMasterId, netAmount, mrp, itemImage, isDelete, maxBuyCount, availableQuantity) {
        var selectCommonItemCart = JSON.parse(localStorage.getItem('selectCommonItemCart')) || []
        let itemNo = itemId + '-' + cmItemSizeId
        if (localStorage.getItem('selectCommonItemCart') == null) {
            if (isDelete == false || quantity > 0) {
                var selectedCommonItemProduct = {
                    storeId: storeId,
                    itemId: itemId,
                    itemName: itemName,
                    quantity: quantity,
                    itemTitle: itemTitle,
                    brand: brand,
                    sizeName: sizeName,
                    sizeId: sizeId,
                    cmItemSizeId: cmItemSizeId,
                    itemMasterId: itemMasterId,
                    netAmount: netAmount,
                    mrp: mrp,
                    itemImage: itemImage,
                    itemNo: itemNo,
                    maxBuyCount: maxBuyCount,
                    availableQuantity: availableQuantity
                }
                selectCommonItemCart.push(selectedCommonItemProduct)
                localStorage.setItem('selectCommonItemCart', JSON.stringify(selectCommonItemCart))
            }
        }
        else {
            var cookieNewCommonItemValue = [];
            var cookieCommonItemArray = selectCommonItemCart;
            var cookieCommonItemUpdated = false
            var cookieCommonItemNewValueCount = 0;
            for (var i = 0; i < cookieCommonItemArray.length; i++) {
                if (cookieCommonItemArray[i] !== null && cookieCommonItemArray[i] !== 'null' && cookieCommonItemArray[i] !== "") {
                    var cookieStoreId = cookieCommonItemArray[i].storeId
                    var cookieItemId = cookieCommonItemArray[i].itemId
                    var cookieCmItemSizeId = cookieCommonItemArray[i].cmItemSizeId.toString().trim()
                    if (itemId === cookieItemId && storeId === cookieStoreId && cookieCmItemSizeId == cmItemSizeId) {
                        if (isDelete === false && quantity > 0) {
                            cookieNewCommonItemValue[cookieCommonItemNewValueCount] =
                            {
                                storeId: storeId,
                                itemId: itemId,
                                itemName: itemName,
                                quantity: quantity,
                                itemTitle: itemTitle,
                                brand: brand,
                                sizeName: sizeName,
                                sizeId: sizeId,
                                cmItemSizeId: cmItemSizeId,
                                itemMasterId: itemMasterId,
                                netAmount: netAmount,
                                mrp: mrp,
                                itemImage: itemImage,
                                itemNo: itemNo,
                                maxBuyCount: maxBuyCount,
                                availableQuantity: availableQuantity
                            }
                            cookieCommonItemNewValueCount++;
                        }
                        cookieCommonItemUpdated = true
                    }
                    else {
                        cookieNewCommonItemValue[cookieCommonItemNewValueCount] = cookieCommonItemArray[i];
                        cookieCommonItemNewValueCount++;
                    }
                }
            }
            if (cookieCommonItemUpdated === false) {
                if (quantity > 0) {
                    cookieNewCommonItemValue[cookieCommonItemNewValueCount] = {
                        storeId: storeId,
                        itemId: itemId,
                        itemName: itemName,
                        quantity: quantity,
                        itemTitle: itemTitle,
                        brand: brand,
                        sizeName: sizeName,
                        sizeId: sizeId,
                        cmItemSizeId: cmItemSizeId,
                        itemMasterId: itemMasterId,
                        netAmount: netAmount,
                        mrp: mrp,
                        itemImage: itemImage,
                        itemNo: itemNo,
                        maxBuyCount: maxBuyCount,
                        availableQuantity: availableQuantity
                    }
                    cookieCommonItemUpdated = true
                }
            }
            localStorage.setItem('selectCommonItemCart', JSON.stringify(cookieNewCommonItemValue))
        }
        $("#cartCount").text((JSON.parse(localStorage.getItem('selectCommonItemCart')).length))
        this.getCartItems();
    }
    isNumberCommonItem = (e, storeId, itemId, itemName, quantity, itemTitle, brand, sizeName, sizeId, cmItemSizeId, itemMasterId, netAmount, mrp, itemImage, maxBuyCount, availableQuantity) => {
        let itemNo = itemId + '-' + cmItemSizeId
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            var prnum = $('.cartInput' + itemNo).val();
        }
        else {
            $('.cartInput' + itemNo).val(1)
        }
        if (maxBuyCount < $('.cartInput' + itemNo).val()) {
            alert("You can buy maximum " + maxBuyCount)
            $('.cartInput' + itemNo).val(maxBuyCount)
        }
        this.addToCartCommonItem("txtChange", storeId, itemId, itemName, quantity, itemTitle, brand, sizeName, sizeId, cmItemSizeId, itemMasterId, netAmount, mrp, itemImage, maxBuyCount, availableQuantity)
    }
    addDefaultSrc(ev) {
        ev.target.src = $("#hid" + ev.target.id).val()
    }

    setStore(groceryobj) {
        window.sessionStorage.setItem('mainGroupCategory', groceryobj.mainGroupCategoryId)
        window.sessionStorage.setItem('storeId', groceryobj.storeId)
        // window.sessionStorage.setItem('cityId',groceryobj.cityId)
        window.location.href = groceryobj.slug
        console.log("groceryobh", groceryobj)
    }
    onLocationTextChangedHandler(keyWord) {
        if (window.sessionStorage.getItem('siteCategoryId') !== "0") {
            this.onLocationTextChanged(keyWord)
        }
        else {
            this.fetchLocationDetails()
        }
    }

    async onLocationTextChanged(keyWord) {
        console.log("*************************************", keyWord)

        if (keyWord == "") {
            $("#cartGlobalListDiv").hide()
        } else {
            const client = new elasticsearch.Client({
                host: elasticHostURL(),
                amazonES: {
                    region: 'us-west-1',
                    // credentials: new AWS.Credentials(this.state.s3AccessKey, this.state.s3SecretKey)
                }
            });
            const body = await client.search({
                index: elasticLink() + '-grouplocation-search',
                from: 0, size: 20,
                body: {
                    query:
                    {
                        bool: {
                            "must": {
                                "multi_match": {
                                    "query": keyWord,
                                    "type": "phrase_prefix",
                                    "fields": ["searchfield"]
                                }
                            },
                        }
                    }
                }
            });
            { console.log("body.hits.hits", body.hits.hits) }
            if (body.hits.hits.length > 0) {
                $("#cartGlobalListDiv").show()
                let locationListNew = body.hits.hits.map(hit => ({
                    locationName: hit._source.locationname,
                    locationId: hit._source.locationid,
                    cityName: hit._source.cityname,
                    cityId: hit._source.cityid,
                    location: hit._source.location,
                    locationNameOnly: hit._source.locationnameonly,
                    stateId: hit._source.stateid,
                    stateName: hit._source.statename,
                    city: hit._source.city
                }));
                this.setState({
                    locationDetails: locationListNew
                });
            }
            else {
                $("#cartGlobalListDiv").hide()
                document.getElementById("error").style.display = "block"

                setTimeout(function () {
                    document.getElementById("error").style.display = "none";
                }, 2000);
                $("#txtGlobalLocation").val("")
                this.setState({
                    locationDetails: [],
                });
            }
            $(".locationClear").show();
        }

    }
    render() {
        var hasLocation = localStorage.getItem('hasLocation')
        let groceryCartItem = JSON.parse(localStorage.getItem('selectedCartProduct'))
        let restaurantCartItemData = JSON.parse(localStorage.getItem('selectRestaurantCart'))
        let commonItemCartData = JSON.parse(localStorage.getItem('selectCommonItemCart'))
        if (null === groceryCartItem || 'null' === groceryCartItem || '' === groceryCartItem) {
            groceryCartItem = []
        }
        if (null === restaurantCartItemData || 'null' === restaurantCartItemData || '' === restaurantCartItemData) {
            restaurantCartItemData = []
        }
        if (null === commonItemCartData || 'null' === commonItemCartData || '' === commonItemCartData) {
            commonItemCartData = []
        }
        let themeId = localStorage.getItem('themeId')
        return (
            <div>
                <div className="cartDivSection">
                    <span className="cartClose cartRemoveItem" onClick={this.props.cartClick}><LazyLoad once><img src={close} alt="" /></LazyLoad></span>
                    {$("#cartCount").text() > 0 ?
                        <div>
                            <h2 class="gsa-mycart text-center">My Cart</h2>
                            {this.state.cartDetails.length > 0 ?
                                this.state.cartDetails.map((cartObject) =>
                                    <div className="cartContentCover cart-cover-gsa">
                                        <div className="cartStoreProduct">
                                            {cartObject.grocery.map((groceryObject, groceryObjectIndex) =>
                                                <div className={cartObject.isMultiple === true ? "cartStoreList cartstoreListMultiple" : "cartStoreList"}>
                                                    <div className="cartStoreListItem">
                                                        <input type="hidden" id={"minimumOrderValue" + groceryObject.storeId} value={groceryObject.minimumOrderValue} />
                                                        <input type="hidden" id={"hasLocation" + groceryObject.storeId} value={groceryObject.hasLocation} />
                                                        <input type="hidden" id={"alwaysDeliver" + groceryObject.storeId} value={groceryObject.alwaysDeliver} />
                                                        <input type="hidden" id={"deliveryCharge" + groceryObject.storeId} value={groceryObject.deliveryCharge} />
                                                        <input type="hidden" id={"onlyFreeDelivery" + groceryObject.storeId} value={groceryObject.onlyFreeDelivery} />
                                                        <input type="hidden" id={"currencySymbol" + groceryObject.storeId} value={groceryObject.currencySymbol} />
                                                        <div className="cartStoreItemList">
                                                            <div className="cartStoreDetails">
                                                                <div className="cartStoreLogo">
                                                                    {(() => {
                                                                        if ((themeId === '34' || themeId === '29' || themeId === '4') && localStorage.getItem('hasGlobalSearch') == "false") {
                                                                            return (
                                                                                <a href={groceryObject.slug}><LazyLoad once><img id={'grocery' + groceryObjectIndex} alt="" onError={this.addDefaultSrc} src={groceryObject.logopath} /></LazyLoad></a>
                                                                            )
                                                                        }
                                                                        else {
                                                                            return (
                                                                                <a href="javascript:void(0);"><LazyLoad once><img id={'grocery' + groceryObjectIndex} alt="" onError={this.addDefaultSrc} src={groceryObject.logopath} /></LazyLoad></a>
                                                                            )
                                                                        }
                                                                    })()}
                                                                    <input type="hidden" id={"hidgrocery" + groceryObjectIndex} value={groceryObject.sellerLogo} />
                                                                    <div className="cartStoreName">{groceryObject.storeName} {groceryObject.locality}</div>
                                                                </div>
                                                                <div className="cartStoreBtns">
                                                                    {(() => {
                                                                        if ((themeId === '34' || themeId === '29' || themeId === '4') && localStorage.getItem('hasGlobalSearch') == "false") {
                                                                            return (
                                                                                <a onClick={(e) => this.setStore(groceryObject)}><span className="cartCommonButton">Store page</span></a>
                                                                            )
                                                                        }
                                                                    })()}
                                                                    <span className="cartCommonButton cartCommonCancel" title={"Remove the item(s) in " + groceryObject.storeName} onClick={(e) => this.deleteStoreFromCart(groceryObject.storeId)}>Remove All</span>
                                                                </div>
                                                            </div>
                                                            <div className="cartProductItemWrap">
                                                                {groceryObject.cartItems.map((groceryCartItems) =>
                                                                    <div className="cartProductItemList gsa-cartProductItemList" id={"productItemList" + groceryObject.storeId + groceryCartItems.itemIndex}>
                                                                        <div className="cartProductItemImage gsa-cartProductItemImage">
                                                                            <LazyLoad once> <img src={groceryCartItems.item_image} alt="" /></LazyLoad>
                                                                        </div>
                                                                        <div className="cartProductItemDetails">
                                                                            <div className="cartProductItemLeft">
                                                                                <div className="cartProductItemName">{groceryCartItems.item_names}</div>
                                                                                <div className="cartProductBrand">{groceryCartItems.brand_name}</div>
                                                                                <div className="cartProductItemPrice ">
                                                                                    {groceryCartItems.pack_name} -
                                                                                    <div className="newPrice">{groceryObject.currencySymbol} {parseFloat(groceryCartItems.item_prices).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</div>
                                                                                    {parseFloat(groceryCartItems.item_prices) < parseFloat(groceryCartItems.mrp) ?
                                                                                        <div className="oldPrice" id={"itemmrp" + groceryObject.storeId + groceryCartItems.itemIndex}>{groceryObject.currencySymbol} {parseFloat(groceryCartItems.mrp).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</div>
                                                                                        : ''}
                                                                                </div>
                                                                            </div>
                                                                            {(() => {
                                                                                if (groceryCartItems.isOutOfStock === '1') {
                                                                                    return (
                                                                                        <div class="isOutOfStock">Sold Out</div>
                                                                                    )
                                                                                }
                                                                                else {
                                                                                    return (
                                                                                        <div className="cartQtyBtn">
                                                                                            <span class="cartQtyDec gsa-cartQtyDec" onClick={(e) => this.addToCart((groceryObject.storeId.toString() + groceryCartItems.itemIndex.toString()), groceryCartItems.storeId, groceryCartItems.store_item_stock_ids, groceryCartItems.item_ids, groceryCartItems.item_prices, groceryCartItems.pack_ids, "dec", groceryCartItems.stock_quantity, groceryCartItems.item_names, groceryCartItems.quantity, groceryCartItems.item_image, groceryCartItems.itemNo)} id={"minuscart" + (groceryObject.storeId.toString() + groceryCartItems.itemIndex.toString())}>-</span>
                                                                                            <span class="cartQtyNumber">
                                                                                                <input type="text" autoComplete="off" className="cartQtyInput" id={"itemQty" + (groceryObject.storeId.toString() + groceryCartItems.itemIndex.toString())} onChange={(e) => this.isNumber(e, (groceryObject.storeId.toString() + groceryCartItems.itemIndex.toString()), groceryCartItems.stock_quantity, groceryCartItems.item_names, groceryCartItems.item_ids, groceryCartItems.item_prices, groceryCartItems.store_item_stock_ids, groceryCartItems.pack_ids, groceryCartItems.quantity, groceryCartItems.item_image, groceryCartItems.itemNo, groceryCartItems.storeId)} value={groceryCartItems.quantity} />
                                                                                            </span>
                                                                                            <span class="cartQtyInc" onClick={(e) => this.addToCart((groceryObject.storeId.toString() + groceryCartItems.itemIndex.toString()), groceryCartItems.storeId, groceryCartItems.store_item_stock_ids, groceryCartItems.item_ids, groceryCartItems.item_prices, groceryCartItems.pack_ids, "inc", groceryCartItems.stock_quantity, groceryCartItems.item_names, groceryCartItems.quantity, groceryCartItems.item_image, groceryCartItems.itemNo)} id={"addcart" + (groceryObject.storeId.toString() + groceryCartItems.itemIndex.toString())}>+</span>
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                            })()}
                                                                            <span className="cartRemoveItem cartremove" title="Remove the item" onClick={(e) => this.addToCart((groceryObject.storeId.toString() + groceryCartItems.itemIndex.toString()), groceryCartItems.storeId, groceryCartItems.store_item_stock_ids, groceryCartItems.item_ids, groceryCartItems.item_prices, groceryCartItems.pack_ids, "remove", groceryCartItems.stock_quantity, groceryCartItems.item_names, groceryCartItems.quantity, groceryCartItems.item_image, groceryCartItems.itemNo)} id={"removecart" + (groceryObject.storeId.toString() + groceryCartItems.itemIndex.toString())}><LazyLoad once><img src={deleteimg} alt="" /></LazyLoad></span>
                                                                        </div>
                                                                        <div className="itemAlertText" id={'qtyErrorCart' + (groceryObject.storeId.toString() + groceryCartItems.itemIndex.toString())}></div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {cartObject.commonItems.map((commonItemObject, groceryObjectIndex) =>
                                                <div className={cartObject.isMultiple === true ? "cartStoreList cartstoreListMultiple" : "cartStoreList"}>
                                                    <div className="cartStoreListItem">
                                                        <div className="cartStoreItemList">
                                                            <div className="cartStoreDetails">
                                                                <div className="cartStoreLogo">
                                                                    {(() => {
                                                                        if (themeId === '34' || themeId === '29' || themeId === '4') {
                                                                            return (
                                                                                <a href={commonItemObject.slug}><LazyLoad once><img id={'common' + groceryObjectIndex} alt="" onError={this.addDefaultSrc} src={commonItemObject.logopath} /></LazyLoad></a>
                                                                            )
                                                                        }
                                                                        else {
                                                                            return (
                                                                                <a href="javascript:void(0);"><LazyLoad once><img id={'common' + groceryObjectIndex} onError={this.addDefaultSrc} src={commonItemObject.logopath} alt="" /></LazyLoad></a>
                                                                            )
                                                                        }
                                                                    })()}
                                                                    <input type="hidden" id={"hidcommon" + groceryObjectIndex} value={commonItemObject.sellerLogo} />
                                                                    <div className="cartStoreName">{commonItemObject.storeName} {themeId == '2' ? "" : commonItemObject.locality}</div>
                                                                </div>
                                                                <div className="cartStoreBtns">
                                                                    {(() => {
                                                                        if (themeId === '34' || themeId === '29' || themeId === '4') {
                                                                            return (
                                                                                <a href="/cmItemListing/0/0/0/"><span className="cartCommonButton">Store page</span></a>
                                                                            )
                                                                        }
                                                                    })()}
                                                                    <span className="cartCommonButton cartCommonCancel" title={"Remove the item(s) in " + commonItemObject.storeName} onClick={(e) => this.deleteStoreFromCart(commonItemObject.storeId)}>Remove All</span>
                                                                </div>
                                                            </div>
                                                            <div className="cartProductItemWrap">
                                                                {commonItemObject.commonItemCartItems.map((commonItemCartItems) =>
                                                                    <div className="cartProductItemList gsa-cartProductItemList" id={"productItemList" + commonItemCartItems.storeId + commonItemCartItems.itemId}>
                                                                        <div className="cartProductItemImage gsa-cartProductItemImage">
                                                                            <LazyLoad once><img src={commonItemCartItems.itemImage} alt="" /></LazyLoad>
                                                                        </div>
                                                                        <div className="cartProductItemDetails">
                                                                            <div className="cartProductItemLeft">
                                                                                <div className="cartProductItemName">{commonItemCartItems.itemName}</div>
                                                                                <div className="cartProductBrand">{commonItemCartItems.brand}</div>
                                                                                <div className="cartProductItemPrice gsa-cartProductItemPrice">
                                                                                    {commonItemCartItems.sizeName} -
                                                                                    <div className="newPrice">{commonItemObject.currencySymbol} {parseFloat(commonItemCartItems.netAmount).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</div>
                                                                                    {parseFloat(commonItemCartItems.netAmount) < parseFloat(commonItemCartItems.mrp) ?
                                                                                        <div className="oldPrice" id={"itemmrp" + commonItemObject.storeId + commonItemCartItems.itemIndex}>{commonItemObject.currencySymbol} {parseFloat(commonItemCartItems.mrp).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</div>
                                                                                        : ''}
                                                                                </div>
                                                                            </div>
                                                                            {(() => {
                                                                                if (commonItemCartItems.isOutOfStock === '1') {
                                                                                    return (
                                                                                        <div class="isOutOfStock">Sold Out</div>
                                                                                    )
                                                                                }
                                                                                else {
                                                                                    return (
                                                                                        <div className="cartQtyBtn">
                                                                                            <span class="cartQtyDec gsa-cartQtyDec" onClick={(e) => this.addToCartCommonItem("dec", commonItemCartItems.storeId, commonItemCartItems.itemId, commonItemCartItems.itemName, commonItemCartItems.quantity, commonItemCartItems.itemTitle, commonItemCartItems.brand, commonItemCartItems.sizeName, commonItemCartItems.sizeId, commonItemCartItems.cmItemSizeId.toString().trim(), commonItemCartItems.itemMasterId, commonItemCartItems.netAmount, commonItemCartItems.mrp, commonItemCartItems.itemImage, commonItemCartItems.maxBuyCount, commonItemCartItems.availableQuantity)} id={"minuscart" + commonItemCartItems.itemId + '-' + commonItemCartItems.cmItemSizeId}>-</span>
                                                                                            <span class="cartQtyNumber">
                                                                                                <input type="text" autoComplete="off" className={"cartQtyInput cartInput cartInput" + commonItemCartItems.itemId + '-' + commonItemCartItems.cmItemSizeId.toString().trim()} id={"txtQty" + commonItemCartItems.itemId + '-' + commonItemCartItems.cmItemSizeId} onChange={(e) => this.isNumberCommonItem(e, commonItemCartItems.storeId, commonItemCartItems.itemId, commonItemCartItems.itemName, commonItemCartItems.quantity, commonItemCartItems.itemTitle, commonItemCartItems.brand, commonItemCartItems.sizeName, commonItemCartItems.sizeId, commonItemCartItems.cmItemSizeId.toString().trim(), commonItemCartItems.itemMasterId, commonItemCartItems.netAmount, commonItemCartItems.mrp, commonItemCartItems.itemImage, commonItemCartItems.maxBuyCount, commonItemCartItems.availableQuantity)} onClick={(e) => this.addToCartCommonItem("txtChange", commonItemCartItems.storeId, commonItemCartItems.itemId, commonItemCartItems.itemName, commonItemCartItems.quantity, commonItemCartItems.itemTitle, commonItemCartItems.brand, commonItemCartItems.sizeName, commonItemCartItems.sizeId, commonItemCartItems.cmItemSizeId.toString().trim(), commonItemCartItems.itemMasterId, commonItemCartItems.netAmount, commonItemCartItems.mrp, commonItemCartItems.itemImage, commonItemCartItems.maxBuyCount, commonItemCartItems.availableQuantity)} value={commonItemCartItems.quantity} />
                                                                                            </span>
                                                                                            <span class="cartQtyInc" onClick={(e) => this.addToCartCommonItem("inc", commonItemCartItems.storeId, commonItemCartItems.itemId, commonItemCartItems.itemName, commonItemCartItems.quantity, commonItemCartItems.itemTitle, commonItemCartItems.brand, commonItemCartItems.sizeName, commonItemCartItems.sizeId, commonItemCartItems.cmItemSizeId.toString().trim(), commonItemCartItems.itemMasterId, commonItemCartItems.netAmount, commonItemCartItems.mrp, commonItemCartItems.itemImage, commonItemCartItems.maxBuyCount, commonItemCartItems.availableQuantity)} id={"addcart" + commonItemCartItems.itemId + '-' + commonItemCartItems.cmItemSizeId}>+</span>
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                            })()}
                                                                            <span className="cartRemoveItem" title="Remove the item" onClick={(e) => this.addToCartCommonItem("remove", commonItemCartItems.storeId, commonItemCartItems.itemId, commonItemCartItems.itemName, commonItemCartItems.quantity, commonItemCartItems.itemTitle, commonItemCartItems.brand, commonItemCartItems.sizeName, commonItemCartItems.sizeId, commonItemCartItems.cmItemSizeId, commonItemCartItems.itemMasterId, commonItemCartItems.netAmount, commonItemCartItems.mrp, commonItemCartItems.itemImage, commonItemCartItems.maxBuyCount, commonItemCartItems.availableQuantity)} id={"removecart" + commonItemCartItems.itemId + '-' + commonItemCartItems.cmItemSizeId}><LazyLoad once><img src={deleteimg} alt="" /></LazyLoad></span>
                                                                        </div>
                                                                        <div className="itemAlertText" id={'qtyErrorCart' + (commonItemObject.storeId.toString() + commonItemCartItems.itemId.toString())}></div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {cartObject.restaurant.map((restaurantObject, groceryObjectIndex) =>
                                                <div className={cartObject.isMultiple === true ? "cartStoreList cartstoreListMultiple" : "cartStoreList"}>
                                                    <div className="cartStoreListItem">
                                                        <div className="cartStoreItemList">
                                                            <div className="cartStoreDetails">
                                                                <div className="cartStoreLogo">
                                                                    {(() => {
                                                                        if (themeId === '34' || themeId === '29' || themeId === '4') {
                                                                            return (
                                                                                <a href={restaurantObject.slug}><LazyLoad once><img id={'restaurant' + groceryObjectIndex} onError={this.addDefaultSrc} src={restaurantObject.logopath} alt="" /></LazyLoad></a>
                                                                            )
                                                                        }
                                                                        else {
                                                                            return (
                                                                                <a href="javascript:void(0);"><LazyLoad once><img id={'restaurant' + groceryObjectIndex} onError={this.addDefaultSrc} src={restaurantObject.logopath} alt="" /></LazyLoad></a>
                                                                            )
                                                                        }
                                                                    })()}
                                                                    <input type="hidden" id={"hidrestaurant" + groceryObjectIndex} value={restaurantObject.sellerLogo} />
                                                                    <div className="cartStoreName">{restaurantObject.storeName} {restaurantObject.locality}</div>
                                                                </div>
                                                                <div className="cartStoreBtns">
                                                                    {(() => {
                                                                        if (themeId === '34' || themeId === '29' || themeId === '4') {
                                                                            return (
                                                                                <a href="/restaurantListing/0/0/"><span className="cartCommonButton">Store page</span></a>
                                                                            )
                                                                        }
                                                                    })()}
                                                                    <span className="cartCommonButton cartCommonCancel" title={"Remove the item(s) in " + restaurantObject.storeName} onClick={(e) => this.deleteStoreFromCart(restaurantObject.storeId)}>Remove All</span>
                                                                </div>
                                                            </div>
                                                            <div className="cartProductItemWrap">
                                                                {restaurantObject.restaurantCartItems.map((restaurantCartItem) =>
                                                                    <div className="cartProductItemList gsa-cartProductItemList" id={"productItemList" + restaurantCartItem.storeId + restaurantCartItem.itemId}>
                                                                        <div className="cartProductItemImage gsa-cartProductItemImage cartProductItemImageRestaurant">
                                                                            <LazyLoad once><img src={restaurantCartItem.itemImage} alt="" /></LazyLoad>
                                                                        </div>
                                                                        <div className="cartProductItemDetails">
                                                                            <div className="cartProductItemLeft">
                                                                                <div className="cartProductItemName">{restaurantCartItem.itemName}</div>
                                                                                <div className="cartProductBrand"></div>
                                                                                <div className="cartProductItemPrice gsa-cartProductItemPrice">
                                                                                    {restaurantCartItem.itemSize} -
                                                                                    <div className="newPrice">{restaurantObject.currencySymbol} {parseFloat(restaurantCartItem.itemMrp).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</div>
                                                                                </div>
                                                                                {restaurantCartItem.toppingsDetails.map((restaurantCartItemsToppings) => (
                                                                                    <div>
                                                                                        <div className="productItemName newPrice">{restaurantCartItemsToppings.name}</div>
                                                                                        {restaurantCartItemsToppings.toppingArray.map((restaurantCartItemsToppingsSub) => (
                                                                                            <div className="productItemName productItemNameLeft">{restaurantCartItemsToppingsSub.name}  <span className="cartProductItemPrice gsa-cartProductItemPrice">  {restaurantCartItemsToppingsSub.price != 0 ? restaurantObject.currencySymbol + ' ' + parseFloat(restaurantCartItemsToppingsSub.price).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') }) : '  (Free)'}</span></div>
                                                                                        ))}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                            {(() => {
                                                                                if (restaurantCartItem.isOutOfStock === '1') {
                                                                                    return (
                                                                                        <div class="isOutOfStock">Sold Out</div>
                                                                                    )
                                                                                }
                                                                                else {
                                                                                    return (
                                                                                        <div className="cartQtyBtn">
                                                                                            <span class="cartQtyDec gsa-cartQtyDec" onClick={(e) => this.addToCartRestaurant("dec", restaurantCartItem.itemId, restaurantCartItem.storeId, restaurantCartItem.itemName, restaurantCartItem.itemMrp, restaurantCartItem.itemImage, restaurantCartItem.itemSize, restaurantCartItem.storeItemSizeId, restaurantCartItem.toppingsData)} id={"minuscart" + restaurantCartItem.itemId + '-' + restaurantCartItem.storeItemSizeId}>-</span>
                                                                                            <span class="cartQtyNumber">
                                                                                                <input type="text" autoComplete="off" className={"cartQtyInput cartInput cartInput" + restaurantCartItem.itemId + '-' + restaurantCartItem.storeItemSizeId + '-' + restaurantCartItem.toppingsData.toString().replace(',', '-')} id={"txtQty" + restaurantCartItem.itemId + '-' + restaurantCartItem.storeItemSizeId + '-' + restaurantCartItem.toppingsData.toString().replace(',', '-')} onChange={(e) => this.isNumberRestaurant(e, restaurantCartItem.itemId, restaurantCartItem.storeId, restaurantCartItem.itemName, restaurantCartItem.itemMrp, restaurantCartItem.itemImage, restaurantCartItem.itemSize, restaurantCartItem.storeItemSizeId, restaurantCartItem.toppingsData)} onClick={(e) => this.addToCartRestaurant("txtChange", restaurantCartItem.itemId, restaurantCartItem.storeId, restaurantCartItem.itemName, restaurantCartItem.itemMrp, restaurantCartItem.itemImage, restaurantCartItem.itemSize, restaurantCartItem.storeItemSizeId, restaurantCartItem.toppingsData)} value={restaurantCartItem.quantity} />
                                                                                            </span>
                                                                                            <span class="cartQtyInc" onClick={(e) => this.addToCartRestaurant("inc", restaurantCartItem.itemId, restaurantCartItem.storeId, restaurantCartItem.itemName, restaurantCartItem.itemMrp, restaurantCartItem.itemImage, restaurantCartItem.itemSize, restaurantCartItem.storeItemSizeId, restaurantCartItem.toppingsData)} id={"addcart" + restaurantCartItem.itemId + '-' + restaurantCartItem.storeItemSizeId}>+</span>
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                            })()}
                                                                            <span className="cartRemoveItem" title="Remove the item" onClick={(e) => this.addToCartRestaurant("remove", restaurantCartItem.itemId, restaurantCartItem.storeId, restaurantCartItem.itemName, restaurantCartItem.itemMrp, restaurantCartItem.itemImage, restaurantCartItem.itemSize, restaurantCartItem.storeItemSizeId, restaurantCartItem.toppingsData)} id={"removecart" + restaurantCartItem.itemId + '-' + restaurantCartItem.storeItemSizeId}><LazyLoad once><img src={deleteimg} alt="" /></LazyLoad></span>
                                                                        </div>
                                                                        <div className="itemAlertText" id={'qtyErrorCart' + (restaurantCartItem.storeId.toString() + restaurantCartItem.itemId.toString())}></div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="cartGrandTotalDiv">
                                            <div className="grandTotalMultiple mb-1">
                                                {cartObject.grocery.map((groceryObject) =>
                                                    <div className="cartStorePrice">
                                                        <div className="cartPriceStoreName">{groceryObject.storeName} :</div>
                                                        {groceryObject.TaxItemPriceFlag === 1 ?
                                                            <div className="cartMrpSection">Sub Total :<span id={"subtotalRs" + groceryObject.storeId}>{groceryObject.currencySymbol} {parseFloat(groceryObject.storeTotalBeforePromoCode).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span></div>
                                                            :
                                                            <div>
                                                                {groceryObject.mrpTotal > 0 ?
                                                                    <div className="cartMrpSection">MRP Price :<span id={"mrptotalRs" + groceryObject.storeId}>{groceryObject.currencySymbol} {parseFloat(groceryObject.mrpTotal).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span></div>
                                                                    : ''}
                                                            </div>
                                                        }
                                                        {groceryObject.discount >= 0 ?
                                                            <div className="cartMrpSection" id={"discountRs" + groceryObject.storeId}>Discount :<span>{groceryObject.currencySymbol} {parseFloat(groceryObject.discount).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span></div>
                                                            : ''}
                                                        {groceryObject.taxData.length > 0 ? groceryObject.taxData.map((taxData) =>
                                                            <div className="cartMrpSection" > {taxData.taxName}({parseFloat(taxData.taxPercentage).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') }) + "%"}):
                                                                <span>
                                                                    {groceryObject.currencySymbol} {parseFloat(taxData.taxAmount).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}
                                                                </span>
                                                            </div>
                                                        )
                                                            : ""
                                                        }
                                                        {hasLocation === "1" ?
                                                            <div className="cartMrpSection" id={"deliveryRs" + groceryObject.storeId} >Delivery :
                                                                {groceryObject.deliveryAmount > 0 ?
                                                                    <span>{groceryObject.currencySymbol} {parseFloat(groceryObject.deliveryAmount).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span>
                                                                    : <span>Free</span>}
                                                            </div>
                                                            : ""}
                                                        <div className="cartMrpSection" id="grandTotal">Total : <span>{groceryObject.isMultiple} {groceryObject.currencySymbol} {parseFloat(groceryObject.grandTotal).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span></div>
                                                        <div className="cartSaveItemDiv">
                                                            {groceryObject.freeShoppingText !== "" ?
                                                                <div className="cartSaveItemText">{groceryObject.freeShoppingText}</div>
                                                                : ''}
                                                            {groceryObject.amountSavedText ?
                                                                <div className="cartSaveItemText" >{groceryObject.amountSavedText}</div>
                                                                : ''}
                                                        </div>
                                                    </div>
                                                )}
                                                {cartObject.commonItems.map((groceryObject) =>
                                                    <div className="cartStorePrice">
                                                        <div className="cartPriceStoreName">{groceryObject.storeName} :</div>
                                                        {groceryObject.mrpTotal > 0 ?
                                                            <div className="cartMrpSection">MRP Price :<span id={"mrptotalRs" + groceryObject.storeId}>{groceryObject.currencySymbol} {parseFloat(groceryObject.mrpTotal).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span></div>
                                                            : ''}
                                                        {groceryObject.discount >= 0 ?
                                                            <div className="cartMrpSection" id={"discountRs" + groceryObject.storeId}>Discount :<span>{groceryObject.currencySymbol} {parseFloat(groceryObject.discount).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span></div>
                                                            : ''}
                                                        {groceryObject.taxData.length > 0 ? groceryObject.taxData.map((taxData) =>
                                                            <div className="cartMrpSection" > {taxData.taxName}({parseFloat(taxData.taxPercentage).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') }) + "%"}):
                                                                <span>
                                                                    {groceryObject.currencySymbol} {parseFloat(taxData.taxAmount).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}
                                                                </span>
                                                            </div>
                                                        )
                                                            : ""
                                                        }
                                                        {hasLocation === "1" ?
                                                            <div className="cartMrpSection" id={"deliveryRs" + groceryObject.storeId} >Delivery :
                                                                {groceryObject.deliveryAmount > 0 ?
                                                                    <span>{groceryObject.currencySymbol} {parseFloat(groceryObject.deliveryAmount).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span>
                                                                    : <span>Free</span>}
                                                            </div>
                                                            : ""}
                                                        <div className="cartMrpSection" id="grandTotal">Total : <span>{groceryObject.isMultiple} {groceryObject.currencySymbol} {parseFloat(groceryObject.grandTotal).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span></div>
                                                        <div className="cartSaveItemDiv">
                                                            {groceryObject.freeShoppingText !== "" ?
                                                                <div className="cartSaveItemText">{groceryObject.freeShoppingText}</div>
                                                                : ''}
                                                            {groceryObject.amountSavedText ?
                                                                <div className="cartSaveItemText" >{groceryObject.amountSavedText}</div>
                                                                : ''}
                                                        </div>
                                                    </div>
                                                )}
                                                {cartObject.restaurant.map((groceryObject) =>
                                                    <div className="cartStorePrice">
                                                        <div className="cartPriceStoreName">{groceryObject.storeName} :</div>
                                                        {groceryObject.mrpTotal > 0 ?
                                                            <div className="cartMrpSection">MRP Price :<span id={"mrptotalRs" + groceryObject.storeId}>{groceryObject.currencySymbol} {parseFloat(groceryObject.mrpTotal).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span></div>
                                                            : ''}
                                                        <div class="checkOutMrpSection">Sub Total :<span>{groceryObject.currencySymbol} {parseFloat(groceryObject.storeTotalBeforePromoCode).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span></div>
                                                        {groceryObject.discount >= 0 ?
                                                            <div className="cartMrpSection" id={"discountRs" + groceryObject.storeId}>Discount :<span>{groceryObject.currencySymbol} {parseFloat(groceryObject.discount).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span></div>
                                                            : ''}
                                                        {groceryObject.taxData.length > 0 ? groceryObject.taxData.map((taxData) =>
                                                            <div className="cartMrpSection" > {taxData.taxName}({parseFloat(taxData.taxPercentage).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') }) + "%"}):
                                                                <span>
                                                                    {groceryObject.currencySymbol} {parseFloat(taxData.taxAmount).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}
                                                                </span>
                                                            </div>
                                                        )
                                                            : ""
                                                        }
                                                        <div className="cartMrpSection" id={"deliveryRs" + groceryObject.storeId} >Delivery :
                                                            {groceryObject.deliveryAmount > 0 ?
                                                                <span>{groceryObject.currencySymbol} {parseFloat(groceryObject.deliveryAmount).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span>
                                                                : <span>Free</span>}
                                                        </div>
                                                        <div className="cartMrpSection" id="grandTotal">Total : <span>{groceryObject.isMultiple} {groceryObject.currencySymbol} {parseFloat(groceryObject.grandTotal).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</span></div>
                                                        <div className="cartSaveItemDiv">
                                                            {groceryObject.freeShoppingText !== "" ?
                                                                <div className="cartSaveItemText">{groceryObject.freeShoppingText}</div>
                                                                : ''}
                                                            {groceryObject.amountSavedText ?
                                                                <div className="cartSaveItemText" >{groceryObject.amountSavedText}</div>
                                                                : ''}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="cartGrandPriceSec pt-4">
                                                <div className="cartGrandPrice">Grand Total : {cartObject.currencySymbol} {parseFloat(cartObject.grandTotalSale).toLocaleString('en-IN', { minimumFractionDigits: window.sessionStorage.getItem('decimalCount'), maximumFractionDigits: window.sessionStorage.getItem('decimalCount') })}</div>

                                                {console.log((localStorage.getItem('locationId')), "Ppppppppppp", ((localStorage.getItem('hasLocation') === '0' && window.sessionStorage.getItem('siteCategoryId') === '0') || (localStorage.getItem('siteGlobalDelivery') === "true")))}
                                                {((localStorage.getItem('hasLocation') === '0' && window.sessionStorage.getItem('siteCategoryId') === '0') || ((localStorage.getItem('siteGlobalDelivery') === "true") && (localStorage.getItem('locationId') === null)) || ((localStorage.getItem('isPincodeBased') === "true") && (localStorage.getItem('locationId') === null))) ?
                                                    <div className="cartGlobal cart-web-global">
                                                        <div className="cartGlobalSearch">
                                                            <div className="input-right input-right-pincode">
                                                                <FontAwesomeIcon icon={faLocationArrow} title={themeId === '2' ? "Enter location to checkout" : "Enter pincode to checkout"} className="cartlocation-arrow" />
                                                                <input onChange={(e) => this.onLocationTextChangedHandler(e.target.value)} autoComplete="off" autoFocus type="text" id="txtGlobalLocation" placeholder={themeId === '2' ? "Enter location to checkout" : "Enter pincode to checkout"} className="cartInputField cartInputwidth" />
                                                                <span className="cartCheckApply cartCheckApplywidth" onClick={(e) => this.removeLocationData()} style={{ display: 'none' }} title="Remove" id="cartGloballocationRemove">X</span>
                                                                <span className="cartCheckApply cartCheckApplywidth" onClick={(e) => this.removeLocationData()} style={{ display: 'none' }} title="Remove" id="cartGloballocationRemove">X</span>
                                                            </div>
                                                        </div>
                                                        <div id="error" className="cartSaveItemDiv" style={{ display: 'none', color: "red" }}>Delivery not available in this location</div>

                                                        {this.state.locationDetails.length > 0 ?
                                                            <div className="cartGlobalList" id="cartGlobalListDiv">
                                                                {this.state.locationDetails.map((location, index1) => (
                                                                    <span className="cartGlobalItem" onClick={(e) => this.setLocationData(location)}>{themeId=== '2' ?location.location :location.locationName}</span>
                                                                ))}
                                                            </div>
                                                            : ''
                                                        }
                                                    </div>
                                                    :
                                                    ""}

                                                <div className="cartGrandButtonDiv" id="cartGrandButtonDiv" style={{ display: (((localStorage.getItem('hasLocation') === '0' && window.sessionStorage.getItem('siteCategoryId') === '0') || ((localStorage.getItem('siteGlobalDelivery') === "true") && (localStorage.getItem('locationId') === null)) || ((localStorage.getItem('isPincodeBased') === "true") && (localStorage.getItem('locationId') === null))) ? 'none' : 'block') }}>
                                                    {(() => {
                                                        if (cartObject.cartDisable === true) {
                                                            return (
                                                                <span className="commonButton cartdisable">Proceed to checkout</span>
                                                            )
                                                        }
                                                        else {
                                                            if (localStorage.getItem('userId') && localStorage.getItem('role') === 'ROLE_BUYER') {
                                                                return (
                                                                    <Link to="/OrderSummary"><span className="commonButton">Proceed to checkout</span></Link>
                                                                )
                                                            }
                                                            else if (localStorage.getItem('userId') && localStorage.getItem('role') !== 'ROLE_BUYER') {
                                                                return (
                                                                    ""
                                                                )
                                                            }
                                                            else {
                                                                return (
                                                                    <span className="commonButton" onClick={this.droploginClick}>Proceed to checkout</span>
                                                                )
                                                            }
                                                        }
                                                    })()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                                :
                                <div className="cartDefault">
                                    {themeId === '30' ? <LazyLoad once><img src={LoaderFragrance} alt="" /></LazyLoad> : <LazyLoad once><img src={cartDefault} alt="" /></LazyLoad>}
                                </div>
                            }
                        </div>
                        :
                        (() => {
                            if (themeId === '34' || themeId === '29' || themeId === '4') {
                                return (
                                    <div className="cartEmpty cartEmptyshow">
                                        <span>Your cart is empty. Start Shopping Now!</span> <LazyLoad once>
                                            {(localStorage.getItem('siteGlobalDelivery') === "true" || localStorage.getItem('hasGlobalSearch') == "true") ? "" :
                                                <img class="cart-empty-icon" alt="" src={Lokal} />
                                            }
                                        </LazyLoad>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div className="cartEmpty cartEmptyshow">
                                        <span>Your cart is empty. Start Shopping Now!</span> <LazyLoad once><img class="cart-empty-icon" alt="" src={brandIcon} /></LazyLoad>
                                    </div>
                                )
                            }
                        })()
                    }
                </div>
            </div>
        )
    }
}
